// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","content":"footer_content__Px8MT","logo":"footer_logo__IRoNB","list":"footer_list__tjFa4","item":"footer_item__D9UCR"};